<template>
  <label :for="id" class="flex h-5 items-center mb-6">
    <input
      :id="id"
      type="checkbox"
      :value="value"
      :checked="value"
      class="h-5 w-5"
      @change="updateInput"
    />
    <div class="ml-2 h-5 align-middle">{{ name }}</div>
  </label>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  emits: ["update:value"],
  props: {
    id: String,
    name: String,
    value: Boolean,
  },
  methods: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    updateInput(e: any) {
      if (e.target.checked) {
        this.$emit("update:value", true);
      } else {
        this.$emit("update:value", false);
      }
    },
  },
})
export default class Checkbox extends Vue {}
</script>
